import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import axios from "axios";
import Checkbox from "@mui/material/Checkbox";
import update from "immutability-helper";
import { ServiceApi } from "../services/index.service";
import AWS from "aws-sdk";
import FlavorTabShimmer from "./FlavorTabShimmer";
import { Chip, Grid, useMediaQuery, useTheme } from "@mui/material";
import { Favorite, FavoriteBorder } from "@mui/icons-material";
import { lemonadesProductId, mangoLemonadeId, sortFrozenRecords, strawberryLemonadeId, topFrozenRecords } from "./FlavorsList";
import StoreOptionsGrid from "./StoreOptionsGrid";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const FavouritesList = (props) => {
  const theme = useTheme();
  const disableSticky = useMediaQuery(theme.breakpoints.down('md'));
  const [store, setStore] = useState([]);
  const [flavorLoading, setFlavorLoading] = useState(false);
  // const [query, setQuery] = useState("");
  const [flavors, setFlavors] = useState([]);
  // const [storeList, setStoreList] = useState([]);
  const [flavorSearch, setFlavorSearch] = useState("");
  const [storeOptions, setStoreOptions] = useState(null);
  const [tCount, setTCount] = useState(4);
  const serviceapi = new ServiceApi();
  const s3 = new AWS.S3();
  // const filteredStores =
  //   query === ""
  //     ? storeList
  //     : storeList.filter((store) => {
  //         let searchString = `${store.intRitasStoreID} - ${store.vchStoreName} - ${store.vchStoreState}`;
  //         return searchString.toLowerCase().includes(query.toLowerCase());
  //       });

  useEffect(() => {
    setStore(props.store);

    //
  }, [props]);

  useEffect(() => {
    setFlavorLoading(props.flavorLoading);
    if (store) setFlavors(props.flavors);
    setStoreOptions(props.storeOptions);
    setTCount(props.tCount);
    // getFlavors();
  }, [
    store,
    props.flavors,
    props.flavorLoading,
    props.storeOptions,
    props.tCount,
  ]);

  // const getStores = async () => {
  //   // const response = await axios.get(`${baseURL}/stores`);
  //   const response = await serviceapi.fetchUserStores();

  //   setStoreList(response);
  //   setStore(response[0]);
  // };
  // const handleStoreChange = (event) => {
  //   setStore(event);
  // };

  const getFlavors = async () => {
    setFlavorLoading(true);
    const req = {
      intStoreID: store?.intStoreID,
      filter: "all",
      category: "actives",
    };
    const response = await serviceapi?.fetchStoreFlavors(req);
    setFlavorLoading(false);
    setFlavors(response);
  };

  const handleFlavorSearch = (event) => {
    setFlavorSearch(event.target.value);
  };

  const clearFilters = () => {
    setFlavorSearch("");
  };

  const handleReset = () => {
    getFlavors();
  };

  const handleSellerCheck = (event, categoryIndex, flavorId, seller) => {
    const flavorIndex = flavors[categoryIndex].flavors.findIndex(
      (f) => f.intFlavorID === flavorId
    );

    const newData = update(flavors, {
      [categoryIndex]: {
        flavors: {
          [flavorIndex]: { [seller]: { $set: event.target.checked } },
        },
      },
    });
    setFlavors(newData);
    // props.activeChangeHandler();

    // setTimeout(() => {
    //   console.log(flavors, "::::::::::::::::::::::::::::::::::::flavors:::");
    // }, 1000);
  };
  const getSignedUrl = (file = "") => {
    const fileData=file.replace("'","")
    return fileData;
  };
  const isThisBlockShow = (cat) => {
    return cat.flavors.some((itm) => props?.tab===0 ? itm.active_rank > 0 : itm.favourite);
  };


  return (
    <div key={props?.tab?.toString()}>
      <main>
        <div className="mx-auto max-w-7xl">
          <div className="px-2 py-1 sm:px-0">
            <div className="rounded-md bg-white "></div>
            {flavorLoading ? (
              <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
                <FlavorTabShimmer />
                <FlavorTabShimmer />
                <FlavorTabShimmer />
                <FlavorTabShimmer />
                <FlavorTabShimmer />
              </div>
            ) : (
              <div>
                <StoreOptionsGrid catering={props?.catering} />
                {store ? (<>
                  {flavors?.length ===0 ? (  <div className="grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
                    {/* The selected store is not enabled for Franchise Console. */}
                  </div>):(
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-5">
                      {flavors?.map((category, categoryIndex) => (
                        <div
                          className="bg-white rounded-md "
                          style={{
                            display: isThisBlockShow(category) ? "" : "none",
                          }}
                        >
                          <div className="card-header-border sticky bg-white z-50 top-[229px]">
                            
                          <div className={`grid divide-x-0`} style={{ gridTemplateColumns: `${props?.catering ? 4 : 1}fr 1.5fr` }}>

                              <div
                                sx={{ width: 8 - `${tCount}` }}
                                className="pl-2 text-card-header"
                              >
                                <h6 className="text-card-header my-5">
                                  {`${category.product_type_name} (${category?.flavors
                                .filter((itm) => props?.tab===0 ? itm.active_rank > 0 : itm.favourite).length})`}
                                </h6>
                              </div>
                              <div sx={{ width: `${tCount}` }}>
                                <div
                                  className={`grid  divide-x my-5 text-center options-card-header`}
                                  style={{gridTemplateColumns:`repeat(${props?.storeOptionsArray?.length + (props?.catering ? 0 : 1)},1fr)`}}
                                >
                                    {!props?.catering && <div>
                                      <label title="All">All</label>
                                    </div>}
                                  {storeOptions.web && (
                                    <div>
                                      <label title="www.ritasice.com">Web</label>
                                    </div>
                                  )}
                                  {storeOptions.dmb && (
                                    <div>
                                      <label title="Digital Menu Boards">
                                        DMB
                                      </label>
                                    </div>
                                  )}
                                  {storeOptions.dt && (
                                    <div>
                                      <label title="Drive Thru">DT</label>
                                    </div>
                                  )}
                                  {storeOptions.oo && (
                                    <div>
                                      <label title="Online Ordering">OO</label>
                                    </div>
                                  )}
                                  {storeOptions.ct && (
                                    <div>
                                      <label title="Catering">CT</label>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                          </div>
                          <div className="flow-root">
                            <ul
                              role="list"
                              className="divide-gray-200 dark:divide-gray-700"
                            >
                              {((category?.intProductTypeID === lemonadesProductId) ? sortFrozenRecords(category?.flavors) : category?.flavors)
                                .filter((itm) => props?.tab===0 ? itm.active_rank > 0 : itm.favourite)
                                .map((flv, flavorIndex) => {
                                  let allValue=true
                                  props?.storeOptionsArray.forEach(i=>{
                                    if(!flv[i?.name]){
                                      allValue=false
                                    }
                                  })

                                  const isMangoLemonade = (lemonadesProductId === flv?.intProductTypeID && flv?.intFlavorID === mangoLemonadeId);
                                  const isStrawberryLemonade = (lemonadesProductId === flv?.intProductTypeID && flv?.intFlavorID === strawberryLemonadeId);

                                  return (
                                    <li key={flavorIndex.toString()} style={{ backgroundColor: lemonadesProductId === flv?.intProductTypeID ? topFrozenRecords.includes(flv?.intFlavorID) && 'aliceblue' : '' }}>
                                      <div className={`grid divide-x-0 card-item-style  pl-2`} style={{ gridTemplateColumns: `${props?.catering ? 4 : 1}fr 1.5fr` }}>
                                        <div
                                          sx={{
                                            width: 8 - `${tCount}`,
                                          }}
                                          className="w-full pt-3"
                                          style={{ display: "flex", paddingLeft: (isMangoLemonade || isStrawberryLemonade) && '10px' }}
                                        >
                                          <span
                                            className="flex-shrink-0 w-7"
                                            style={{
                                              // display: "inline-block",
                                              verticalAlign: "bottom",
                                            }}
                                          >
                                            <img
                                              className="rounded-full"
                                              src={getSignedUrl(
                                                flv.thumbnailURL
                                              )}
                                              onError={(event) => {
                                                event.target.src =
                                                "../assets/icons/circle.png";
                                                event.onerror = null;
                                              }}
                                              alt="flavorImage"
                                            />
                                            {!props?.catering && <Checkbox
                                                onChange={(e) =>
                                                  props.handleSellerCheckFromChild(
                                                    e,
                                                    categoryIndex,
                                                    flv?.intFlavorID,
                                                    "favourite",
                                                    flv?.fid
                                                  )
                                                }
                                                id={`favourite-${flv?.intFlavorID}-${categoryIndex}`}
                                                checked={flv?.favourite}
                                                style={{
                                                  position: "absolute",
                                                  marginTop: "-40px",
                                                  marginLeft: "10px",
                                                }}
                                                size="small"
                                                icon={
                                                  <FavoriteBorder className="text-gray-300 favorite-icon-tour-selector" />
                                                }
                                                checkedIcon={
                                                  <Favorite color="error" className="favorite-icon-tour-selector"/>
                                                }
                                              />}
                                          </span>
                                          <span
                                            style={{
                                              fontSize: (isMangoLemonade || isStrawberryLemonade) ? "11.5px" : "12.5px",
                                              paddingLeft: "12px",
                                              paddingTop: "6px",
                                            }}
                                          >
                                            {flv?.flavor_name}
                                          </span>
  
                                          {/* <Checkbox
                                            icon={<FavoriteBorder />}
                                            checkedIcon={<Favorite />}
                                          /> */}
                                        </div>
                                        <div
                                          sx={{
                                            width: `${tCount}`,
                                          }}
                                        >
                                          <div
                                            className={`grid text-center`}  style={{gridTemplateColumns:`repeat(${props?.storeOptionsArray?.length + (props?.catering ? 0 : 1)},1fr)`}}
                                          >
                                            {!props?.catering && <div>
                                                {" "}
                                                <Checkbox
                                                  disabled={flv?.product_type_name === "Flavor Driven Treats" || isMangoLemonade || isStrawberryLemonade}
                                                  sx={{
                                                    "&.Mui-disabled": {
                                                      pointerEvents: "auto",
                                                      "&:hover": {
                                                        backgroundColor:
                                                          "transparent",
                                                      },
                                                      cursor: "not-allowed",
                                                      "& [class*=MuiSvgIcon-root]":
                                                        {
                                                          // fill: "#FFF",
                                                          backgroundColor:
                                                            "#D1D1D1",
                                                          borderRadius: "25% ",
                                                        },
                                                    },
                                                  }}
                                                  size="small"
                                                  checked={allValue}
                                                  onChange={(e) =>
                                                    props.handleAllSellerCheck(
                                                      e,
                                                      categoryIndex,
                                                      flv?.intFlavorID,
                                                    )
                                                  }
                                                  style={{
                                                    color: allValue
                                                      ? "#1CBF8E"
                                                      : "#ADB5BD",
                                                  }}
                                                />{" "}
                                              </div>}
                                            {storeOptions.web && (
                                              <div>
                                                {" "}
                                                <Checkbox
                                                className="web-checkbox-tour-selector"
                                                  disabled={
                                                    flv?.product_type_name ===
                                                    "Flavor Driven Treats"
                                                      ? true
                                                      : false
                                                  }
                                                  sx={{
                                                    "&.Mui-disabled": {
                                                      pointerEvents: "auto",
                                                      "&:hover": {
                                                        backgroundColor:
                                                          "transparent",
                                                      },
                                                      cursor: "not-allowed",
                                                      "& [class*=MuiSvgIcon-root]":
                                                        {
                                                          // fill: "#FFF",
                                                          backgroundColor:
                                                            "#D1D1D1",
                                                          borderRadius: "25% ",
                                                        },
                                                    },
                                                  }}
                                                  size="small"
                                                  checked={flv?.web}
                                                  onChange={(e) =>
                                                    props.handleSellerCheckFromChild(
                                                      e,
                                                      categoryIndex,
                                                      flv?.intFlavorID,
                                                      "web"
                                                    )
                                                  }
                                                  style={{
                                                    color: flv?.web
                                                      ? "#1CBF8E"
                                                      : "#ADB5BD",
                                                  }}
                                                />{" "}
                                              </div>
                                            )}
  
                                            {storeOptions.dmb && (
                                              <div>
                                                {" "}
                                                <Checkbox
                                                  className="dmb-checkbox-tour-selector"
                                                  disabled={ flv?.bitLTO || !flv?.bitIsOptional || flv?.product_type_name === "Flavor Driven Treats" || isMangoLemonade || isStrawberryLemonade}
                                                  sx={{
                                                    "&.Mui-disabled": {
                                                      pointerEvents: "auto",
                                                      "&:hover": {
                                                        backgroundColor:
                                                          "transparent",
                                                      },
                                                      cursor: "not-allowed",
                                                      "& [class*=MuiSvgIcon-root]":
                                                        {
                                                          // fill: "#FFF",
                                                          backgroundColor:
                                                            "#D1D1D1",
                                                          borderRadius: "25% ",
                                                        },
                                                    },
                                                  }}
                                                  size="small"
                                                  checked={flv?.dmb}
                                                  onChange={(e) =>
                                                    props.handleSellerCheckFromChild(
                                                      e,
                                                      categoryIndex,
                                                      flv?.intFlavorID,
                                                      "dmb"
                                                    )
                                                  }
                                                  style={{
                                                    color: flv?.dmb
                                                      ? "#1CBF8E"
                                                      : "#ADB5BD",
                                                  }}
                                                />{" "}
                                              </div>
                                            )}
  
                                            {storeOptions.dt && (
                                              <div>
                                                <Checkbox
                                                  className="dt-checkbox-tour-selector"
                                                  disabled={ flv?.bitLTO || !flv?.bitIsOptional || flv?.product_type_name === "Flavor Driven Treats" || isMangoLemonade || isStrawberryLemonade}
                                                  sx={{
                                                    "&.Mui-disabled": {
                                                      pointerEvents: "auto",
                                                      "&:hover": {
                                                        backgroundColor:
                                                          "transparent",
                                                      },
                                                      cursor: "not-allowed",
                                                      "& [class*=MuiSvgIcon-root]":
                                                        {
                                                          // fill: "#FFF",
                                                          backgroundColor:
                                                            "#D1D1D1",
                                                          borderRadius: "25% ",
                                                        },
                                                    },
                                                  }}
                                                  size="small"
                                                  checked={flv?.dt}
                                                  onChange={(e) =>
                                                    props.handleSellerCheckFromChild(
                                                      e,
                                                      categoryIndex,
                                                      flv?.intFlavorID,
                                                      "dt"
                                                    )
                                                  }
                                                  style={{
                                                    color: flv?.dt
                                                      ? "#1CBF8E"
                                                      : "#ADB5BD",
                                                  }}
                                                />
                                              </div>
                                            )}
  
                                            {storeOptions.oo && (
                                              <div>
                                                <Checkbox
                                                  className="oo-checkbox-tour-selector"
                                                  size="small"
                                                  checked={flv?.oo}
                                                  onChange={(e) =>
                                                    props.handleSellerCheckFromChild(
                                                      e,
                                                      categoryIndex,
                                                      flv?.intFlavorID,
                                                      "oo"
                                                    )
                                                  }
                                                  style={{
                                                    color: flv?.oo
                                                      ? "#1CBF8E"
                                                      : "#ADB5BD",
                                                  }}
                                                />
                                              </div>
                                            )}
                                            {storeOptions.ct && (
                                              <div>
                                                <Checkbox
                                                  className="ct-checkbox-tour-selector"
                                                  size="small"
                                                  checked={flv?.ct}
                                                  onChange={(e) =>
                                                    props.handleSellerCheckFromChild(
                                                      e,
                                                      categoryIndex,
                                                      flv?.intFlavorID,
                                                      "ct"
                                                    )
                                                  }
                                                  style={{
                                                    color: flv?.ct
                                                      ? "#1CBF8E"
                                                      : "#ADB5BD",
                                                  }}
                                                />
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  );
                                })}
                            </ul>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </>
                ) : (
                  <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
                    Please select a store
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default FavouritesList;